export default __webpack_public_path__ + "static/media/icon_lab orders_pressed..0388e591.svg";